import { Flex, SystemProps, Text, UnderlineButton } from "flicket-ui";
import styled from "styled-components";

import { useAtom } from "jotai";
import { Icon } from "~components";

import {
  Details,
  ticketDetailsAtom,
} from "~features/seated-reservation/components/common/modal.TicketDetails";
import {
  googleAnalyticsMembershipAtom,
  googleAnalyticsReleaseAtom,
  trackViewItemV4,
} from "~hooks/useGoogleAnalytics";
import { useOrganization } from "~hooks";
import { IReleaseTicket } from "~features/nonseated-reservation/nonseated-reservation.types";
import { Info } from "phosphor-react";

const ToolTip = styled(Flex)<SystemProps>`
  position: relative;
  align-items: center;

  &&& button:hover {
    color: ${(p) => p.theme.colors.N600};
    opacity: 0.8;
    transition: background 0.2s, box-shadow 0.15s, border-color 0.2s, color 0.2s,
      opacity 0.2s;
  }
`;

interface IListItemDetails {
  ticketType: IReleaseTicket;
}

export const ListItemDetails = ({ ticketType }: IListItemDetails) => {
  const { name, legacyDescription, restrictions, image, price } = ticketType;

  if (!legacyDescription && !restrictions) {
    return null;
  }

  const { organization } = useOrganization();

  const [, setTicketDetails] = useAtom(ticketDetailsAtom);
  const [release] = useAtom(googleAnalyticsReleaseAtom);
  const [membership] = useAtom(googleAnalyticsMembershipAtom);

  return (
    <ToolTip>
      <UnderlineButton
        color="N600"
        onClick={() => {
          //  @ts-expect-error atom type issue while using strict:false
          setTicketDetails({
            name,
            description: legacyDescription,
            restrictions,
            ticketImage: image,
          });
          trackViewItemV4(organization, {
            item: ticketType,
            seated: ticketType && "category" in ticketType ? true : false,
            release,
            membership,
            price,
          });
        }}
      >
        <Icon color="N800" icon={<Info />} fontSize={3} mr="1/2" />
        <Text variant="small">Details</Text>
      </UnderlineButton>
    </ToolTip>
  );
};

export default ListItemDetails;
